import React, { memo, forwardRef } from 'react';
import { Grid, Divider, Typography, Hidden } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  description?: React.ReactNode;
  children: React.ReactNode;
  isCheckoutStyle?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    background: theme.palette.background.paper,
    [theme.breakpoints.down('md')]: {
      boxShadow: '0px -6px 32px rgba(0, 0, 0, 0.2)',
    },
  },
  container: {
    padding: theme.spacing(2, 0),
    height: 104,
    [theme.breakpoints.down('md')]: {
      height: 72,
    },
  },
  containerExtended: {
    height: 104,
    [theme.breakpoints.down('md')]: {
      height: 88,
    },
  },

  buttonContainer: {
    marginTop: 8,
    marginRight: 32,
    marginLeft: 8,
    [theme.breakpoints.down('md')]: {
      marginTop: 4,
      marginRight: 8,
      marginLeft: 8,
    },
  },
  description: {
    fontWeight: 600,
    textAlign: 'right',
    fontSize: 11,
    lineHeight: '150%',
    color: theme.palette.text.primary,
    marginTop: 16,
    marginRight: 32,
    [theme.breakpoints.down('md')]: {
      marginTop: 4,
      marginRight: 16,
    },
  },
}));

const BottomNavigation = forwardRef<HTMLDivElement, IProps>(
  ({ isCheckoutStyle = false, description, children }, ref) => {
    const { classes } = useStyles();

    return (
      <div className={classes.root} ref={ref}>
        <Hidden mdDown>{isCheckoutStyle ? <Divider /> : <Divider light />}</Hidden>
        <Grid className={description ? classes.containerExtended : classes.container} container>
          <Grid item xs={12}>
            {description && (
              <Grid item>
                <Typography className={classes.description} color="textSecondary" variant="caption" component="p">
                  {description}
                </Typography>
              </Grid>
            )}
            <Grid className={classes.buttonContainer} item>
              {children}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  },
);

export default memo(BottomNavigation);
